export default __webpack_public_path__ + "static/media/colors.5e2bcea8.jpg";